import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const zones = [
  'zone_1', 'zone_2', 'zone_3', 'zone_4', 'zone_5',
  'zone_6', 'zone_7', 'zone_8', 'zone_9', 'zone_10',
];

export default function ZonesDesservies() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="zones" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className={`text-center mb-10 md:mb-12 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('zones_h2')}
          </h2>
          <p className="text-slate-primary/50 text-sm md:text-base">{t('zones_intro')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Map */}
          <div className={`transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="rounded-xl overflow-hidden h-64 md:h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d89450.61313062317!2d-71.1878719!3d46.8085061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb90005c90966af%3A0x8cbe3c6b2aa45bfa!2sL%C3%A9vis%2C%20QC!5e0!3m2!1sfr!2sca!4v1700000000000!5m2!1sfr!2sca"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Carte des zones desservies par Couvreur-Lévis.com"
                aria-label="Carte Google Maps des zones de service à Lévis"
              />
            </div>
          </div>

          {/* Zone list */}
          <div className={`transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="grid grid-cols-2 gap-3">
              {zones.map((z, idx) => (
                <div key={idx} className="flex items-center gap-2.5 bg-white rounded-lg px-4 py-3">
                  <i className="ri-map-pin-2-line text-copper" />
                  <span className="text-slate-primary text-sm font-medium">{t(z)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}